import angular from 'angular';

angular.module('cloudX').directive('cxCountrySelect', [
  'optionsSvc',
  'dataCache',
  function(optionsSvc, dataCache) {
    return {
      restrict: 'E',
      template:
        '<a href="#" editable-select="country" ' +
        'onbeforesave="save({newValue:$data})"' +
        "e-ng-options=\"country.id as country.label for country in countries | orderBy:['-isCommon', '+label']\"" +
        'edit-disabled="disabled">' +
        '<span ng-show="country" ng-bind="country | translateList:\'country\'"></span>' +
        '<i class="glyphicon glyphicon-pencil" ng-hide="country"></i></a>',
      scope: {
        country: '=data',
        save: '&',
        disabled: '=?',
        required: '=?',
      },
      controller: [
        '$scope',
        '$filter',
        '$rootScope',
        function($scope, $filter, $rootScope) {
          var options = dataCache.getArray('country');
          var mapOptions = function() {
            var mappedCountries = options.map(val => ({
              id: val.code,
              label: $filter('translateList')(val.code, 'country', val.name),
              isCommon: val.isCommon,
            }));

            if (!$scope.required) {
              var emptyOption = {
                id: null,
                label: '',
                isCommon: true,
              };
              mappedCountries.unshift(emptyOption);
            }

            $scope.countries = mappedCountries;
          };

          mapOptions();
          var deregistration = $rootScope.$on('$translateChangeSuccess', mapOptions);
          $scope.$on('$destroy', deregistration);
        },
      ],
    };
  },
]);
